import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignBusinessEmploymentModel } from './types';
import { foreignBusinessEmploymentItemValidator } from './validators/item';

const foreignBusinessEmploymentValidator: ValidateJSModel<ForeignBusinessEmploymentModel> = {
  HasForeignEmployment: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignEmployment?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessEmploymentItemValidator },
      };
    }

    return {};
  },
};
export default foreignBusinessEmploymentValidator;
